import { render } from "./RealtorBenefits.vue?vue&type=template&id=5e41a5c7"
const script = {}

import "./RealtorBenefits.vue?vue&type=style&index=0&id=5e41a5c7&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__